var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-cl-transparent brdr-none inline-flex",attrs:{"type":"button","aria-label":_vm.$t('Open search panel'),"data-testid":"openSearchPanel"},on:{"click":_vm.toggleSearchpanel}})
}
var staticRenderFns = []

export { render, staticRenderFns }